import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import addressListAdapter from "@/redux/slice/location/adapters/addressList";

const selectLocation = (state: RootState) => state?.location;

const addressListSelector = createDraftSafeSelector(selectLocation, (location) => location?.addressList);

// Export the customized selectors for patientDetails adapter using `getSelectors`
export const {
  selectAll: selectAllAddresses,
  selectById: selectAddressById,
  selectIds: selectAddressIds,
} = addressListAdapter.getSelectors(
  // Pass in a selector that returns the patientDetails field of auth slice of state
  addressListSelector
);
